import { ETrackerEvents, trackCustom } from '../index';

import { formatTrackerMoney, type IRechargePayExtras } from './recharge-result';

/** 创单成功且拿到业务订单号时上报 */
export function trackOrderCreate(params: {
    order_id: string;
    gear_id: string;
    payExtras: IRechargePayExtras;
    payment_method: string;
}): void {
    const { order_id, gear_id, payExtras, payment_method } = params;
    if (!order_id?.trim()) {
        return;
    }

    const payload: Record<string, string | number> = {
        order_id,
        gear_id,
        money: formatTrackerMoney(payExtras.money),
        goods_type: payExtras.goods_type,
        payment_method,
    };
    if (payExtras.goods_type === 'recharge') {
        payload.coin = payExtras.coin ?? 0;
        payload.bonus = payExtras.bonus ?? 0;
    }

    trackCustom(ETrackerEvents.ORDER_CREATE, payload);
}
